import { IthresholdDataToPost } from '@/components/ThresholdCard/Ithreshold';
import APIService from '@/api';

export default class ThresholdService extends APIService {
  getThresholdList() {
    return this.get(
      '/admin/threshold?limit=100&extras=status:created&sort=threshold.createdAt:ASC'
    );
  }

  updateThreshold({ id, data }: { id: string; data: IthresholdDataToPost }) {
    return this.put(`/admin/threshold/${id}`, data);
  }

  newThreshold(data: IthresholdDataToPost) {
    return this.post(`/admin/threshold/`, data);
  }

  deleteThreshold(id: string) {
    return this.delete(`/admin/threshold/${id}`);
  }

  getDailyTransactions() {
    return this.get('/admin/threshold/transaction/amount/daily?period=7');
  }

  getItemTransactions() {
    return this.get('/admin/threshold/transaction/amount/item');
  }

  getCTSTransactions(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `/admin/threshold/transactions?`,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }

  getCTSTransaction(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    transactionId: string
  ) {
    const resource = this.generateResource(
      `/admin/threshold/transactions?`,
      sortField,
      sortOrder,
      '&skip=0&limit=1000&',
      `searchableFields=threshold.id&search=${transactionId}`
    );
    return this.get(resource);
  }
}
